import { getParam, setParams } from '@lib/utils'

export function usePageParam({ key, defaultValue = "", onSelect, items = [], labelRender, preserveState = false }) {

  let value = $derived(getParam(key, defaultValue) || "")

  let selected = $derived(items.find(item => item.value == value))
  let selectedItem = $derived(selected || items[0])

  let label = $derived.by(() => {
    const text = selected?.label || items[0]?.label || "Select"
    return labelRender ? labelRender(text) : text
  })

  function setValue(value) {
    setParams({ [key]: value, page: 1 }, { preserveState })
  }

  return {
    key,
    items,
    setValue,
    get value() { return value },
    get selected() { return selected },
    get selectedItem() { return selectedItem },
    get label() { return label },
    get icon() { return selectedItem?.icon },
  }
  
}